import { Stack } from "@certn/cascadia";
import { Illustration, Text } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function SkipDsConsent({ clientName }: { clientName?: string }) {
  const { t } = useTranslation();

  return (
    <>
      <Text style="form/body-primary">
        {t(
          "We acknowledge your decision to opt out of Disclosure Scotland consent. A criminal record check will not be submitted to Disclosure Scotland. {{clientName}} will contact you to agree next steps. In the meantime, please complete the rest of this application.",
          {
            clientName,
          }
        )}
      </Text>
      <Stack orientation="horizontal" justify="center">
        <Illustration size={200} name="messages" />
      </Stack>
    </>
  );
}
